"use client";
import React, { useState } from "react";
import Image from "next/image";
import Step1 from "../Step1";
import Step2 from "../Step2";
import Step3 from "../Step3";
import { Form, Formik } from "formik";
import Step4 from "../Step4";
import Step5 from "../Step5";
import step1b from "@/public/images/step1b.svg";
import step1g from "@/public/images/step1g.svg";
import step2b from "@/public/images/step2b.svg";
import step2g from "@/public/images/step2g.svg";
import step3b from "@/public/images/step3b.svg";
import step3g from "@/public/images/step3g.svg";
import step4b from "@/public/images/step4b.svg";
import step4g from "@/public/images/step4g.svg";

import { useAppDispatch } from "@/redux/store";

import AUTH from "@/redux/Auth";
import {
  registerSchema1,
  registerSchema2,
  registerSchema3,
  registerSchema4,
} from "@/lib/Shemas";
import { useRouter } from "next/navigation";

const index = () => {
  const [step, setstep] = useState(1);
  const [selectedTeachers, setselectedTeachers] = useState<any>([]);
  const [loading, setloading] = useState(false);

  const dispatch = useAppDispatch();
  const [errors, seterrors] = useState({
    step1: false,
    step2: true,
    step3: true,
    step4: true,
    step5: true,
  });

  const [dataForRegister, setdataForRegister] = useState({
    schoolName: "",
    country: "",
    city: "",
    schoolYear: "",
    educationType: "",
    secondLanguage: "",
    schoolType: "",
    fullName: "",
    gender: "",
    fatherJob: "",
    fatherPhone: "",
    nationalId: "",
    nationalFront: null,
    nationalBack: null,
    profileImage: null,
    phone: "",
    userName: "",
    email: "",
    password: "",
    confirmPassword: "",
    code: "",
  });
  // const router = useRouter();

  // useEffect(() => {
  //   {
  //     step === 5 && router.push("/login");
  //   }
  // }, [step]);
  return (
    <div className=" ">
      {step < 5 && (
        <>
          <div className=" flex gap-10 relative w-full xl:w-fit overflow-auto hideScroll  mb-16">
            <div
              className={` z-[1] shrink-0 cursor-pointer flex items-center gap-4  rounded-[10px] pl-[70px] pr-[20px] lg:px-[20px] py-[10px] lg:w-fit ${
                step === 1 ? "bg-[#323538]" : "bg-[#26292C]"
              }`}
              onClick={() => {
                if (errors.step1 === false) {
                  setstep(1);
                }
              }}
            >
              <div
                className={`w-[44px] h-[44px] flex items-center justify-center rounded-full ${
                  step === 1 ? "bg-primaryColor" : "bg-[#323538]"
                }`}
              >
                <Image
                  src={step === 1 ? step1b : step1g}
                  alt="personalInformation"
                />
              </div>

              <div>
                <p className=" text-16 text-white text-nowrap">
                  معلوماتك الدراسية
                </p>
                <p className=" text-14 text-textColor font-[300] text-nowrap">
                  اضف معلوماتك الدراسية
                </p>
              </div>
            </div>{" "}
            <div
              className={` z-[1] shrink-0 cursor-pointer flex items-center gap-4  rounded-[10px] pl-[70px] pr-[20px] lg:px-[20px] py-[10px] lg:w-fit ${
                step === 2 ? "bg-[#323538]" : "bg-[#26292C]"
              }`}
              onClick={() => {
                if (errors.step3 === false) {
                  setstep(3);
                }
              }}
            >
              <div
                className={`w-[44px] h-[44px] flex items-center justify-center rounded-full ${
                  step === 2 ? "bg-primaryColor" : "bg-[#323538]"
                }`}
              >
                <Image
                  src={step === 2 ? step2b : step2g}
                  alt="personalInformation"
                />
              </div>

              <div>
                <p className=" text-16 text-white text-nowrap">
                  معلوماتك الشخصية
                </p>
                <p className=" text-14 text-textColor font-[300] text-nowrap">
                  يسعدنا ان نتعرف بك
                </p>
              </div>
            </div>{" "}
            <div
              className={` z-[1] shrink-0 cursor-pointer flex items-center gap-4  rounded-[10px] pl-[70px] pr-[20px] lg:px-[20px] py-[10px] lg:w-fit ${
                step === 3 ? "bg-[#323538]" : "bg-[#26292C]"
              }`}
              onClick={() => {
                if (errors.step4 === false) {
                  setstep(4);
                }
              }}
            >
              <div
                className={`w-[44px] h-[44px] flex items-center justify-center rounded-full ${
                  step === 3 ? "bg-primaryColor" : "bg-[#323538]"
                }`}
              >
                <Image
                  src={step === 3 ? step3b : step3g}
                  alt="personalInformation"
                />
              </div>

              <div>
                <p className=" text-16 text-white text-nowrap">
                  معلوماتك السرية
                </p>
                <p className=" text-14 text-textColor font-[300] text-nowrap">
                  اضف معلوماتك السرية
                </p>
              </div>
            </div>{" "}
            <div
              className={` z-[1] shrink-0 cursor-pointer flex items-center gap-4  rounded-[10px] pl-[70px] pr-[20px] lg:px-[20px] py-[10px] lg:w-fit ${
                step === 3 ? "bg-[#323538]" : "bg-[#26292C]"
              }`}
              onClick={() => {
                if (errors.step4 === false) {
                  setstep(4);
                }
              }}
            >
              <div
                className={`w-[44px] h-[44px] flex items-center justify-center rounded-full ${
                  step === 4 ? "bg-primaryColor" : "bg-[#323538]"
                }`}
              >
                <Image
                  src={step === 4 ? step4b : step4g}
                  alt="personalInformation"
                />
              </div>

              <div>
                <p className=" text-16 text-white text-nowrap">تأكيد الحساب</p>
                <p className=" text-14 text-textColor font-[300] text-nowrap">
                  ادخل كود التأكيد
                </p>
              </div>
            </div>{" "}
            <span className=" bg-[#323538] h-[2px] w-[200%] md:w-full absolute top-1/2 -translate-y-1/2 z-[0] "></span>
          </div>
          <div className=" mb-10">
            <p className=" text-40 text-white font-[500]">
              انشاء حساب معنا بخطوات بسيطة
            </p>
            <p className=" text-16 text-textColor font-[500] max-w-[922px]">
              يرجي ملئ البيانات بدقة ويجب ان تكون صحيحة حيث يتم مراجعة البيانات
              من الدعم الفني للمنصة وفي حالة حدوث خطأ لن يتم تفعيل الحساب
            </p>
          </div>
        </>
      )}
      <div className={`${step == 1 ? "" : "hidden"}`}>
        <Formik
          initialValues={{
            schoolName: "",
            country: "",
            city: "",
            schoolYear: "",
            educationType: "",
            secondLanguage: "",
            schoolType: "",
          }}
          validationSchema={registerSchema1}
          onSubmit={(values) => {
            setdataForRegister((prev) => ({ ...prev, ...values }));
            setstep(step + 1);
          }}
        >
          {(props) => {
            return (
              <Form>
                <div className={`${step != 1 && "hidden"}`}>
                  <Step2 formikProps={props} />
                </div>
                <div className=" flex gap-5 my-10">
                  <button
                    type="submit"
                    className=" primaryButton cursor-pointer"
                    disabled={loading}
                  >
                    <p className={`${loading && "hidden"}`}>الخطوة التالية</p>
                    <div
                      className={`w-5 h-5 rounded-full animate-spin text-center mx-auto
                    border-2 border-solid border-blue-500 border-t-transparent ${
                      !loading && "hidden"
                    }`}
                    ></div>
                  </button>

                  {step > 1 && (
                    <p
                      onClick={() => {
                        setstep(step - 1);
                      }}
                      className=" secondaryButton cursor-pointer "
                    >
                      رجوع
                    </p>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className={`${step === 2 ? "" : "hidden"}`}>
        <Formik
          initialValues={{
            fullName: "",
            gender: "",
            fatherJob: "",
            fatherPhone: "",
            nationalId: "",
            nationalFront: null,
            nationalBack: null,
          }}
          validationSchema={registerSchema2}
          onSubmit={(values) => {
            setloading(true);
            setdataForRegister((prev) => ({ ...prev, ...values }));
            setloading(false);
            step === 2 && setstep(step + 1);
          }}
        >
          {(props) => {
            return (
              <Form>
                <div className={`${step != 2 && "hidden"}`}>
                  <Step1 formikProps={props} />
                </div>

                <div className=" flex gap-5 my-10">
                  <button
                    type="submit"
                    className=" primaryButton cursor-pointer "
                  >
                    <p className={`${loading && "hidden"}`}>الخطوة التالية</p>
                    <div
                      className={`w-5 h-5 rounded-full animate-spin text-center mx-auto
                    border-2 border-solid border-blue-500 border-t-transparent ${
                      !loading && "hidden"
                    }`}
                    ></div>
                  </button>

                  {step > 1 && (
                    <p
                      onClick={() => {
                        setstep(step - 1);
                      }}
                      className=" secondaryButton cursor-pointer "
                    >
                      رجوع
                    </p>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className={`${step === 3 ? "" : "hidden"}`}>
        <Formik
          initialValues={{
            profileImage: null,
            phone: "",
            userName: "",
            email: "",
            password: "",
            confirmPassword: "",
          }}
          validationSchema={registerSchema3}
          onSubmit={(values) => {
            setdataForRegister((prev) => ({ ...prev, ...values }));
            const formData: any = new FormData();
            formData.append("gender", dataForRegister.gender);
            formData.append("city_id", dataForRegister.city);
            formData.append("area_id", dataForRegister.country);
            formData.append("school_name", dataForRegister.schoolName);
            formData.append("school_year_id", dataForRegister.schoolYear);
            formData.append("school_type_id", dataForRegister.schoolType);
            formData.append("language_id", dataForRegister.secondLanguage);
            dataForRegister.educationType &&
              formData.append(
                "education_type_id",
                dataForRegister.educationType
              );
            formData.append("parent_job", dataForRegister.fatherJob);
            formData.append("parent_mobile", `${dataForRegister.fatherPhone}`);
            formData.append("national_id_number", dataForRegister.nationalId);
            formData.append("national_id_front", dataForRegister.nationalFront);
            formData.append("national_id_back", dataForRegister.nationalBack);
            formData.append("image", values.profileImage);
            formData.append("name", dataForRegister.fullName);
            formData.append("mobile", `${values.phone}`);
            formData.append("username", values.userName);
            formData.append("email", values.email);
            formData.append("password", values.password);
            formData.append("password_confirmation", values.confirmPassword);
            selectedTeachers.forEach((item: any, index: number) => {
              formData.append(`teachers[${index}]`, item);
            });
            setloading(true);
            dispatch(AUTH.thunks.doRegister({ data: formData })).then((res) => {
              setloading(false);
              res.meta.requestStatus === "fulfilled" && setstep(6);
            });
          }}
        >
          {(props) => {
            return (
              <Form>
                <div className={`${step != 3 && "hidden"}`}>
                  <Step3 formikProps={props} />
                </div>

                <div className=" flex gap-5 my-10">
                  <button
                    type="submit"
                    className=" primaryButton cursor-pointer flex items-center justify-center "
                    disabled={loading}
                  >
                    <p className={`${loading && "hidden"}`}>انشاء حساب</p>
                    <div
                      className={`w-5 h-5 rounded-full animate-spin text-center mx-auto
                    border-2 border-solid border-blue-500 border-t-transparent ${
                      !loading && "hidden"
                    }`}
                    ></div>
                  </button>

                  {step > 1 && (
                    <p
                      onClick={() => {
                        setstep(step - 1);
                      }}
                      className=" secondaryButton cursor-pointer "
                    >
                      رجوع
                    </p>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <>
        <div className={`${step === 5 ? "" : "hidden"}`}>
          <Formik
            initialValues={{
              code: "",
            }}
            validationSchema={registerSchema4}
            onSubmit={(values) => {
              const formData: any = new FormData();
              formData.append("mobile", dataForRegister.phone);
              formData.append("code", values.code);
              formData.append("type", "verify");
              //
              // setdataForRegister((prev) => ({ ...prev, ...values }));
              setloading(true);
              values.code &&
                dispatch(AUTH.thunks.doVerifyCode({ data: formData })).then(
                  (res) => {
                    // if (res.meta.requestStatus === "fulfilled") {
                    // setstep(step + 1);
                    // seterrors((prev) => ({
                    //   ...prev,
                    //   step5: false,
                    // }));
                    // }
                    setloading(false);
                    res.meta.requestStatus === "fulfilled" &&
                      step === 5 &&
                      setstep(step + 1);
                  }
                );
            }}
          >
            {(props) => {
              //

              return (
                <Form>
                  <div className={`${step != 5 && "hidden"}`}>
                    <Step4 formikProps={props} mobile={dataForRegister.phone} />
                  </div>

                  <div className=" flex gap-5 my-10">
                    <button
                      type="submit"
                      className=" primaryButton cursor-pointer "
                      disabled={loading}
                    >
                      <p className={`${loading && "hidden"}`}>تفعيل الحساب</p>
                      <div
                        className={`w-5 h-5 rounded-full animate-spin text-center mx-auto
                    border-2 border-solid border-blue-500 border-t-transparent ${
                      !loading && "hidden"
                    }`}
                      ></div>
                    </button>

                    {step > 1 && (
                      <p
                        onClick={() => {
                          setstep(step - 1);
                        }}
                        className=" secondaryButton cursor-pointer "
                      >
                        رجوع
                      </p>
                    )}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </>
      {step === 6 && <Step5 step={step} setstep={setstep} />}
    </div>
  );
};

export default index;
